import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TxtViewerComponent } from './txt-viewer.component';

@NgModule({
    declarations: [
        TxtViewerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TxtViewerComponent
    ]
})
export class NcTxtViewerModule { }